/**
 * 店舗詳細スタッフカード：storeDetail__staffBodyHead を行ごとに高さ揃え（jquery-match-height）
 */
import $ from 'jquery';
import 'jquery-match-height';

function debounce(fn, ms) {
	let t;
	return (...args) => {
		clearTimeout(t);
		t = setTimeout(() => fn.apply(null, args), ms);
	};
}

export function initStoreDetailStaffBodyHeadMatchHeight() {
	const root = document.querySelector('.storeDetail');
	if (!root) return;

	const lists = root.querySelectorAll('.storeDetail__staffList');
	if (!lists.length) return;

	const update = () => {
		lists.forEach((list) => {
			const $heads = $(list).find('.storeDetail__staffBodyHead');
			if (!$heads.length) return;
			$heads.matchHeight('remove');
			$heads.matchHeight({ byRow: true });
		});
	};

	update();

	const onResize = debounce(update, 150);
	window.addEventListener('resize', onResize);

	if (document.fonts?.ready) {
		document.fonts.ready.then(update);
	}

	if (typeof ResizeObserver !== 'undefined') {
		const ro = new ResizeObserver(debounce(update, 100));
		lists.forEach((list) => ro.observe(list));
	}
}
